module.exports = __webpack_public_path__ + "static/media/face_verification.dc22e64a.png";